type WrappedKeys<T extends object, S extends string> = {
  [K in keyof T]: K extends string ? `${S}__${K}` : never
}

/**
 * Wraps each key of an action list with a specified namespace prefix followed by double underscores.
 * This function is useful for avoiding key collisions in larger applications or libraries.
 *
 * @param {S} namespace - A string representing the namespace to prefix the keys with.
 * @param {T} actions - An object containing keys that represent action types.
 * @returns {WrappedKeys<T, S>} - An object with the same keys as the input 'actions' but each key
 *                                transformed into a namespaced string literal.
 */
export function keyWrapper<T extends object, S extends string>(
  namespace: S,
  actions: T,
): WrappedKeys<T, S>
export function keyWrapper(
  namespace: string,
  actions: object,
): Record<string, string> {
  const result: Record<string, string> = {}

  for (const key of Object.keys(actions)) {
    result[key] = `${namespace}__${key}`
  }

  return result
}

export default keyWrapper
